export enum EVENTS_NAME {
  currentSceneReady = "current-scene-ready",
  currentSceneReadyContinued = "current-scene-ready-continued",
  chestLoot = "chest-loot",
  attack = "attack",
  gameEnd = "game-end",
  zoneEnter = "zone-enter",
  showStoryline = "show-story-line",
  storylineResponse = "storyline-response",
  showChallenge = "show-challenge",
  showInteractiveChallenge = "show-interactive-challenge",
  clearGameUi = "clear-game-ui",
  music = "music",
  playerMove = "player-move",
  engageLaptop = "engage-laptop",
  tookDamage = "took-damage",
  showGameOutro = "show-game-outro",
  showGameOutroContinued = "show-game-outro-continued",
  interactResource = "interact-resource",
  wrongPhrase = "wrong-phrase",
  correctPhrase = "correct-phrase",
  remotePlayerInfo = "remote-player-info",
  removePlayer = "remove-player",
  bootedGame = "booted-game",
  playerInfo = "player-info",
  playerDied = "player-died",
  entitySnapshot = "entity-snapshot",
  guessAiResult = "guess-ai-result",
  wsOpen = "ws-open",
  // ── server-authoritative combat monsters ──
  supportMobInfo = "support-mob-info", // server broadcast: mob state
  removeSupportMob = "remove-support-mob", // server: mob died/despawned
  mobControl = "mob-control", // server: controller lease grant/revoke
  mobMove = "mob-move", // controller client -> ws: position report
  mobDamage = "mob-damage", // local player hit a mob -> ws
  playerDamaged = "player-damaged", // a mob hit the LOCAL player -> ws
  showMonsterIntro = "show-monster-intro", // first monster sighted -> tutorial
  monsterIntroClosed = "monster-intro-closed", // tutorial dismissed -> resume
  worldState = "world-state", // server: con-wide state (currently just boss_defeated)
  cipherVictory = "cipher-victory", // 0a's cipher (mission 5000) solved -> the 60s show
}

export enum GameStatus {
  WIN,
  LOSE,
}

export const DEFAULT_PLAYER_START_LOCATION = [128, 3780];
export const DEFAULT_ZONE_ID = 1;

export const MAP_DIM_VAL = 32;
